import { parse, stringify } from './urlHelpers';

// Includes booking-prefill params (capacity / dates / time) plus the topbar search context
// (address / origin / bounds) so the searchbar pill on the listing page reflects the search
// the user came from. `espacio` carries the listing face (piscina / jardín) so the card the
// user clicked and the page they land on show the same version of the space.
const PREFILL_KEYS = ['pub_capacity', 'dates', 'time', 'address', 'origin', 'bounds', 'espacio'];

/**
 * Copia solo los params de búsqueda útiles para precargar la reserva en el listing.
 */
export function extractListingPrefillQueryString(searchString) {
  const p = parse(searchString || '', { latlng: ['origin'], latlngBounds: ['bounds'] });
  const o = {};
  PREFILL_KEYS.forEach(k => {
    if (p[k] != null && String(p[k]).trim() !== '') {
      o[k] = p[k];
    }
  });
  return Object.keys(o).length ? stringify(o) : '';
}

export function appendPrefillQueryToPath(path, searchString) {
  const [base, existingSearch = ''] = String(path).split('?');
  const existing = parse(existingSearch);
  const prefill = parse(extractListingPrefillQueryString(searchString));
  // Lo que el llamante ya puso en el path manda: si duplicáramos la clave, `parse`
  // devolvería un array al leerla y el valor dejaría de reconocerse.
  const merged = { ...prefill, ...existing };
  const q = Object.keys(merged).length ? stringify(merged) : '';
  return q ? `${base}?${q}` : base;
}

/**
 * Query string de la ficha: el de la barra de direcciones manda sobre el del router,
 * que a veces se queda atrás al hidratar y dejaría la cara (piscina/jardín) desfasada
 * respecto a la fecha que sí ve el formulario de reserva.
 */
export const browserSearchString = (fallback = '') => {
  if (
    typeof window !== 'undefined' &&
    typeof window.location?.search === 'string' &&
    window.location.search
  ) {
    return window.location.search;
  }
  return fallback || '';
};

/**
 * @returns {{ guestCount?: string, startDateYmd?: string, endDateYmd?: string, startTimeHm?: string, endTimeHm?: string } | null}
 */
export function parseListingBookingPrefill(locationSearch) {
  const p = parse(locationSearch || '', { latlng: ['origin'], latlngBounds: ['bounds'] });
  const out = {};
  if (p.pub_capacity != null && String(p.pub_capacity).trim() !== '') {
    out.guestCount = String(p.pub_capacity).trim();
  }
  if (p.dates != null && String(p.dates).trim() !== '') {
    const datesValue = Array.isArray(p.dates) ? p.dates[0] : p.dates;
    const parts = String(datesValue).split(',');
    if (parts[0]) {
      out.startDateYmd = parts[0].trim();
    }
    if (parts[1]) {
      out.endDateYmd = parts[1].trim();
    } else if (parts[0]) {
      out.endDateYmd = parts[0].trim();
    }
  }
  if (p.time != null && String(p.time).trim() !== '') {
    const tparts = String(p.time).split(',');
    if (tparts[0]) {
      out.startTimeHm = normalizeHourMinute(tparts[0].trim());
    }
    if (tparts[1]) {
      out.endTimeHm = normalizeHourMinute(tparts[1].trim());
    }
  }
  return Object.keys(out).length ? out : null;
}

function normalizeHourMinute(s) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(s);
  if (!m) {
    return s;
  }
  const h = String(parseInt(m[1], 10)).padStart(2, '0');
  const min = m[2];
  return `${h}:${min}`;
}
